import { render, staticRenderFns } from "./MainNavMenuItem.vue?vue&type=template&id=307139b9&"
import script from "./MainNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./MainNavMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainNavMenuItem.vue"
export default component.exports